import {ReactNode} from 'react';
import {OrbitComponentWithState} from "../orbit-component-with-state/orbit-component-with-state";



export class OrbitComponent<TProps = {children?: ReactNode | undefined}> extends OrbitComponentWithState<TProps, {}> {
}



